import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ShadeToolsService} from '../../../../../core/services/shade-tools.service';
import {DevicesService} from '../../../../../core/services/devices.service';
import {HubsService} from '../../../../../core/services/hubs.service';
import {Protocol} from '../../../../../shared/models/protocol';
import {DeviceType} from '../../../../../shared/models/device';
import {SubtitleItem} from '../../../../../core/state/title.state';
import {TitleChangedAction} from '../../../../../core/actions/title.actions';
import {Store} from '@ngrx/store';
import {AppState} from '../../../../../app/app.state';
import {BacnetDeviceDiscoveryComponent} from './bacnet-device-discovery/bacnet-device-discovery.component';
import {DeviceEditorComponent} from '../../../../components/device-editor/device-editor.component';
import {SpinnerComponent} from '../../../../components/spinner/spinner.component';
import {FaIconComponent} from '../../../../components/fa-icon/fa-icon.component';

@Component({
  selector: 'motn-devices-new',
  templateUrl: './devices-new.component.html',
  styleUrls: ['./devices-new.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    BacnetDeviceDiscoveryComponent,
    DeviceEditorComponent,
    SpinnerComponent,
    FaIconComponent,
  ],
})
export class DevicesNewComponent implements OnInit {
  // Expose enum to template
  readonly DeviceType = DeviceType;

  discoveringBacnetDevices: boolean = false;
  manuallyEnteringProtocol: Protocol;
  loadingLoRaWANHubs: boolean = false;


  constructor(
    private hubsService: HubsService,
    private devicesService: DevicesService,
    private shadeTools: ShadeToolsService,
    private store: Store<AppState>,
  ) {
  }


  ngOnInit(): void {
    this.updateTitle();
  }


  protected updateTitle() {
    const subtitle: SubtitleItem[] = [{
      text: 'Ready to add more',
    }];

    this.store.dispatch(new TitleChangedAction(
      '',
      'Devices',
      subtitle,
    ));
  }


  openManualEntry(protocol: Protocol) {
    this.manuallyEnteringProtocol = protocol;
  }


  handleOTAAClick() {
    this.loadingLoRaWANHubs = true;

    this.hubsService.getUserHubs$().subscribe({
      next: (hubs) => {
        this.loadingLoRaWANHubs = false;

        const cloudHubs = hubs.filter(h => h.Type === 'cloud');

        if (cloudHubs.length === 0) {
          this.shadeTools.simpleOkDialog(
            'Add LoRaWAN Device',
            'To add a LoRaWAN device, a Cloud Hub is required. You do not currently have a Cloud Hub. To add a Cloud Hub, contact your Motion account representative.',
          );
        } else {
          this.manuallyEnteringProtocol = DeviceType.LoRaWAN;
        }
      },
      error: () => {
        this.loadingLoRaWANHubs = false;
        this.shadeTools.errorDialog();
      },
    });
  }
}
